import LogoIcon from "@/public/assets/app-images/blazeo_actual.png";

const getNotificationAPI = () => {
  if (typeof window === "undefined") return null;
  if (!("Notification" in window)) return null;
  return window.Notification;
};

const useDesktopNotification = () => {
  const requestPermission = (data) => {
    const Notify = getNotificationAPI();
    if (!Notify) return;

    try {
      if (Notify.permission === "default") {
        Notify.requestPermission().then((res) => {
          if (res === "granted" && data) {
            showNotification(data);
          }
        });
      }
    } catch {
      // Notifications are unavailable (iOS Safari / Chrome)
    }
  };

  const showNotification = async (data = {}) => {
    const Notify = getNotificationAPI();
    if (!Notify) return;

    try {
      if (Notify.permission === "granted") {
        new Notify(data?.title, { body: data?.body, icon: LogoIcon });
      } else if (Notify.permission === "default") {
        requestPermission(data);
      }
    } catch {
      // Notifications are unavailable (iOS Safari / Chrome)
    }
  };

  return {
    requestPermission,
    showNotification,
  };
};

export default useDesktopNotification;
